import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=b7bb3576&scoped=true&"
var script = {}
import style0 from "./NavBar.vue?vue&type=style&index=0&id=b7bb3576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bb3576",
  null
  
)

export default component.exports